import { FilterConditions, INSERT, SELECT, UPDATE } from "@/utils/database_module"
import { Banner, BannerOptionalFields,  Product, SecondaryBanner } from "@/utils/types"
type DBBanner = Omit<Banner, "product" > & { product_id: number; }

type SecondaryBannerRequiredFields =  Omit<SecondaryBanner,  "id" | "date" | "modified_date">
type BannerRequiredFields = Omit<Banner, "product" | "id" | "date" | "modified_date">  & {product_id? : number};


const banners = {
    
    getAll: async (is_admin : boolean , is_main? : boolean  , is_cars?: boolean) => {
       
        const conditions : FilterConditions = [{column : "is_deleted" , operator : "=" , value : 0}, {column : "is_main" , operator : "=" , value : is_main ? 1 : 0 ,} , {column : "is_cars" , operator : "=" , value : is_cars ? 1 : 0 ,}]
        if(is_main) conditions.push({column : "is_main" , operator : "=" , value : 1})
        if (is_cars) conditions.push({column : "is_cars" , operator : "=" , value : 1})
        
        if (!is_admin) conditions.push({column : "is_active" , operator : "=" , value : 1})
        const queryResult = (await SELECT("banners" , { conditions : conditions , order : "date DESC"})) as DBBanner[] | SecondaryBanner[];
        
        if (!is_main) {
            return queryResult as SecondaryBanner[];
        }
        
        const banners = queryResult as DBBanner[];
        return banners;
    },

    update : async (id : number , banner : BannerOptionalFields | SecondaryBannerRequiredFields) => {
        const updatedBanner = await UPDATE("banners" , banner , [{column : "id" , operator : "=" , value : id}])
        return updatedBanner
    },

    insert : async (banner : BannerRequiredFields | SecondaryBannerRequiredFields ) => {
        return await INSERT("banners" , banner)
    },

    delete : async (id : number) => {
        return await UPDATE("banners" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}



export default banners
